import {CLIENT_DISCOUNT_CODES} from './siteIds'

const config = {
  clientId: CLIENT_DISCOUNT_CODES,
  clientUrl: 'https://www.discountcodes.com/',
  privacyPolicyUrl: 'https://discountcodes.com/terms',
  termsUrl: 'https://discountcodes.com/terms',
  appName: 'Discountcodes.com',
  siteName: 'Discountcodes.com',
  price: 24.99,
  currency: 'USD',
  currencySymbol: '$',
  primaryColor: 'red',
  outlineFocusColor: 'focus:outline-blue-600',
  bgColor: 'bg-blue-600',
  hoverColor: 'bg-blue-600',
  focusVisibleColor: `focus-visible:outline-blue-600`,
  textColor: `text-blue-600`,
  hoverTextColor: `hover:text-blue-500`,
  brands: [
    {
      name: 'at&t',
      slug: 'att',
      logo: '/popular-brands/at-and-t-wireless.png',
    },
    {name: 'avis', logo: '/popular-brands/avis.png'},
    {name: 'bose', logo: '/popular-brands/bose.png'},
    {
      name: 'h&r block',
      slug: 'hrblock',
      logo: '/popular-brands/h-and-r-block.png',
    },
    {name: 'lenovo', logo: '/popular-brands/lenovo.png'},
    {name: 'oreo', logo: '/popular-brands/oreo.png'},
    {name: 'szul', logo: '/popular-brands/szul.png'},
    {name: 'tj maxx', slug: 'tjmaxx', logo: '/popular-brands/tj-maxx.png'},
    {name: 'betterhelp', logo: '/popular-brands/betterhelp.png'},
    {name: 'grammarly', logo: '/popular-brands/grammarly.png'},
  ],
}
export default config
